<template>
  <div id="app">
    <NavBar />
    <transition
      name="fade"
      mode="out-in"
      @beforeLeave="beforeLeave"
      @enter="enter"
      @afterEnter="afterEnter"
    >
      <div style="min-height: 400px">
        <router-view />
      </div>
    </transition>
    <FooterBar />
    <AskMediaMachine />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import NavBar from '@/components/NavBar'
import FooterBar from '@/components/FooterBar'
import AskMediaMachine from '@/components/AskMediaMachine'
import config from '@/config'

export default {
  name: 'Home',
  components: {
    FooterBar,
    NavBar,
    AskMediaMachine
  },
  metaInfo() {
    return {
      titleTemplate: `%s | ${config.appName}`,
      htmlAttrs: {
        lang: 'en'
      },
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: "License the content you've always wanted within your budget"
        }
      ]
    }
  },
  created() {
    this.isAuthenticated()
  },
  methods: {
    ...mapActions(['isAuthenticated']),
    beforeLeave(element) {
      this.prevHeight = getComputedStyle(element).height
    },
    enter(element) {
      const { height } = getComputedStyle(element)

      element.style.height = this.prevHeight

      setTimeout(() => {
        element.style.height = height
      })
    },
    afterEnter(element) {
      element.style.height = 'auto'
    }
  }
}
</script>

<style>
html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
}

#app {
  min-height: 100%;
  position: relative;
}

.footer {
  width: 100%;
  position: absolute;
  bottom: -120px;
  left: 0;
}
@media screen and (min-width: 768px) {
  .footer {
    bottom: -30px;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: height, opacity;
  transition-timing-function: ease-in-out;
  overflow: hidden;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

/* Global modal text visibility fixes */
.modal .modal-card-body,
.modal .modal-card-head,
.modal .modal-card-foot,
.modal .card-content {
  color: #363636 !important;
}

.modal .modal-card-title {
  color: #363636 !important;
}

.modal .table,
.modal .table td,
.modal .table th {
  color: #363636 !important;
}

.modal .button {
  color: #363636 !important;
}

.modal .button.is-primary,
.modal .button.is-warning,
.modal .button.is-danger,
.modal .button.is-info {
  color: white !important;
}

.modal .tag {
  color: white !important;
}

.modal .has-text-grey {
  color: #7a7a7a !important;
}

.modal .has-text-grey-light {
  color: #b5b5b5 !important;
}

.modal .has-text-weight-bold {
  color: #363636 !important;
}

.modal .has-text-danger {
  color: #f14668 !important;
}

.modal .has-text-success {
  color: #48c774 !important;
}

.modal pre {
  color: #363636 !important;
}
</style>
